export const isStaging = (hostName = '') => {
  const lowerHostName = hostName.toLowerCase();
  return (
    lowerHostName.search(`stg.bennie.com`) >= 0 ||
    lowerHostName.search(`stage.bennie.com`) >= 0
  );
};

export const isDev = (hostName = '') => {
  return hostName.toLowerCase().search(`devops.bennie.com`) >= 0;
};

export const isProd = (hostName = '') => {
  return (
    !isStaging(hostName) &&
    !isDev(hostName) &&
    hostName.toLowerCase().search(`bennie.com`) >= 0
  );
};

export const ZENDESK_ENVS = {
  PROD: 'PROD',
  SANDBOX: 'SANDBOX',
};

export const getZendeskEnvFromEnvironment = (envConfig) =>
  envConfig?.ENVIRONMENT === 'Production' ? ZENDESK_ENVS.PROD : ZENDESK_ENVS.SANDBOX;

/**
 * Check if user should be redirected from BCA and handle the redirect
 * @param {Object} user - The user object from UMS
 * @returns {boolean} Returns true if redirect happened, false if user can continue with app
 */
export const handleBCARedirect = user => {
  if (!user || user.bcaAccess !== false) {
    return false;
  }

  const hostName = window.location.hostname;
  let environment;

  if (isStaging(hostName)) {
    environment = 'stage';
  } else if (isProd(hostName)) {
    environment = 'pr';
  } else {
    environment = 'devops';
  }

  const profileUrl = `https://my-profile.${environment}.bennie.com`;

  window.location.href = profileUrl;
  return true;
};

// artemis-web (monorepo-ui-web) deploys under the `artemis-web` subdomain in every
// environment; local dev serves it on vite port 3009.
const ARTEMIS_WEB_LOCAL_URL = 'http://localhost:3009';
const ARTEMIS_WEB_SUBDOMAIN = 'artemis-web';

/**
 * Resolve the artemis-web origin for the environment we are currently served from.
 * Mirrors handleBCARedirect's host-derived URL construction, so no extra runtime env
 * var has to be plumbed through server/env-config.js and the deploy overlays.
 * @param {string} hostName - defaults to the current window hostname
 * @returns {string} artemis-web origin, no trailing slash
 */
export const getArtemisWebUrl = (hostName = window.location.hostname) => {
  if (hostName === 'localhost' || hostName === '127.0.0.1') {
    return ARTEMIS_WEB_LOCAL_URL;
  }

  let environment;
  if (isStaging(hostName)) {
    environment = 'stage';
  } else if (isProd(hostName)) {
    environment = 'pr';
  } else {
    environment = 'devops';
  }

  return `https://${ARTEMIS_WEB_SUBDOMAIN}.${environment}.bennie.com`;
};
